import ByteChunksView from '../byteChunksView';
import { byteChunksToInt } from '../utils';
import PngChunkView from './pngChunkView';

export default class AnimationControlChunkView extends PngChunkView
{
    private readonly rawFramesNumber: ByteChunksView;
    private readonly rawPlaysNumber: ByteChunksView;

    constructor(rawData: Uint8Array[])
    {
        super(rawData, 8);
        [this.rawFramesNumber, this.rawPlaysNumber] = this.rawContent.split(4);

        if (this.framesNumber === 0)
        {
            throw new Error(`Invalid number of frame ${this.framesNumber}`);
        }
    }

    get framesNumber(): number
    {
        return byteChunksToInt(this.rawFramesNumber.getRawChunks());
    }

    get playsNumber(): number
    {
        return byteChunksToInt(this.rawPlaysNumber.getRawChunks());
    }
}
